import React, { useState, useEffect } from 'react';
import { CountdownFormat, CountdownUnite } from './CountdownEnum';
import clsx from 'clsx';
import { hashClass } from '../../helpers';
import { is } from '../../services';
import { useTrilogyContext } from '../../context';
const calculateTimer = (timeDifference) => {
    const seconds = Math.floor((timeDifference / 1000) % 60);
    const minutes = Math.floor((timeDifference / 1000 / 60) % 60);
    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return { days, hours, minutes, seconds };
};
/**
 * Countdown Component
 * @param deadline {Date} Date to reach before the end of the countdown
 * @param format {CountdownFormat} Format of countdown
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param event
 * @param small
 * @param centered
 * @param others
 */
const Countdown = ({ deadline, className, format, event, small, ...others }) => {
    const { styled } = useTrilogyContext();
    const [timeLeft] = useState(deadline);
    const initialTimeDifference = deadline.getTime() - new Date().getTime();
    const initialTimer = calculateTimer(initialTimeDifference);
    const [timer, setTimer] = useState(initialTimer);
    const [init, setInit] = useState(false);
    const show = [timer.days != 0, timer.hours != 0, timer.minutes != 0, timer.seconds != 0];
    const parsedFormat = format === null || format === void 0 ? void 0 : format.split('-');
    const classes = hashClass(styled, clsx('countdown', small && is('small'), className));
    if (parsedFormat) {
        parsedFormat.forEach((item) => {
            switch (item) {
                case 'dd':
                    show[CountdownUnite.DAY] = true;
                    break;
                case 'hh':
                    show[CountdownUnite.HOUR] = true;
                    break;
                case 'mm':
                    show[CountdownUnite.MIN] = true;
                    break;
                case 'ss':
                    show[CountdownUnite.SEC] = true;
                    break;
                default:
                    break;
            }
        });
    }
    else {
        show[CountdownUnite.DAY] = true;
        show[CountdownUnite.HOUR] = true;
        show[CountdownUnite.MIN] = true;
        show[CountdownUnite.SEC] = true;
    }
    useEffect(() => {
        setInterval(() => {
            const difference = timeLeft.getTime() - new Date().getTime();
            if (difference > 0) {
                switch (format) {
                    case CountdownFormat.DAY:
                        setTimer({
                            days: Math.ceil(difference / (1000 * 60 * 60 * 24)),
                            hours: 0,
                            minutes: 0,
                            seconds: 0,
                        });
                        break;
                    case CountdownFormat.DAY_HOUR:
                        setTimer({
                            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                            hours: Math.ceil((difference / (1000 * 60 * 60)) % 24),
                            minutes: 0,
                            seconds: 0,
                        });
                        break;
                    case CountdownFormat.DAY_HOUR_MIN:
                        setTimer({
                            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                            minutes: Math.ceil((difference / 1000 / 60) % 60),
                            seconds: 0,
                        });
                        break;
                    default:
                        setTimer({
                            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                            minutes: Math.floor((difference / 1000 / 60) % 60),
                            seconds: Math.floor((difference / 1000) % 60),
                        });
                        break;
                }
            }
            setInit(true);
        }, 1000);
    }, [timeLeft, format]);
    useEffect(() => {
        if (timer.days + timer.hours + timer.minutes + timer.seconds === 0 && event && init) {
            event(null);
            setInit(false);
        }
    }, [timer, event, init]);
    return (React.createElement("ul", { className: classes, ...others },
        (show[CountdownUnite.DAY] || timer.days != 0) && (React.createElement("li", { className: hashClass(styled, clsx('count')) },
            React.createElement("span", { className: hashClass(styled, clsx('value')) }, timer.days ? timer.days : 0),
            "j")),
        (show[CountdownUnite.HOUR] || timer.hours != 0) && (React.createElement("li", { className: hashClass(styled, clsx('count')) },
            React.createElement("span", { className: hashClass(styled, clsx('value')) }, timer.hours ? timer.hours : 0),
            "h")),
        (show[CountdownUnite.MIN] || timer.minutes != 0) && (React.createElement("li", { className: hashClass(styled, clsx('count')) },
            React.createElement("span", { className: hashClass(styled, clsx('value')) }, timer.minutes ? timer.minutes : 0),
            "m")),
        (show[CountdownUnite.SEC] || timer.seconds != 0) && (React.createElement("li", { className: hashClass(styled, clsx('count')) },
            React.createElement("span", { className: hashClass(styled, clsx('value')) }, timer.seconds ? timer.seconds : 0),
            "s"))));
};
export default Countdown;
//# sourceMappingURL=Countdown.js.map